import { AbstractControl } from '@angular/forms';

export function PasswordValidation(control: AbstractControl) {
  const passwordCriteria = RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)[a-zA-Z\\d!@#$&*]{8,128}$');
  return passwordCriteria.test(control.value) ? null : { invalidPassword: { value: control.value } };
}
